import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  collapseContainer: {
    width: '100%',
  },
  paperContainer: {
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(1, 2),
  },
  wrapperInner: {
    padding: theme.spacing(2, 0, 0),
  },
}));

export default useStyles;
